import { TesterTypeBase } from './base/tester-type-base';

export class TesterType extends TesterTypeBase { }